// -----------------------------
// src/admin/components/AssignTaskCard.js
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DashboardFeatureCard from './cards/DashboardFeatureCard';

export default function AssignTaskCard({
  onSearch = null,
  colSize = 'col-12',
  initialAssetSearch = '',
}) {
  const [query, setQuery] = useState(initialAssetSearch);

  const handleSearch = () => {
    if (onSearch) {
      onSearch(query.trim());
    }
  };

  useEffect(() => {
    if (initialAssetSearch) {
      setQuery(initialAssetSearch);
      if (onSearch) onSearch(initialAssetSearch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialAssetSearch]);

  return (
    <DashboardFeatureCard
      className={colSize}
      title="Assign New Task"
      footer="Search for an asset to assign a task for it. You can use asset ID, location, or any other identifier."
    >
      <form
        onSubmit={(event) => {
          event.preventDefault();
          handleSearch();
        }}
      >
        <label className="form-label" htmlFor="assign-task-asset-search">
          Search Asset
        </label>
        <div className="d-flex">
          <div className="input-group flex-grow-1 me-2">
            <input
              id="assign-task-asset-search"
              type="text"
              className="form-control"
              placeholder="Enter asset ID or location..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
            <span className="input-group-text">
              <i className="bi bi-search" />
            </span>
          </div>
          <button type="submit" className="btn btn-primary">
            Search
          </button>
        </div>
      </form>
    </DashboardFeatureCard>
  );
}

AssignTaskCard.propTypes = {
  onSearch: PropTypes.func,
  colSize: PropTypes.string,
  initialAssetSearch: PropTypes.string,
};
